module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("join.header.h1")))]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#job1"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job1")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job2"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job2")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job3"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job3")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job4"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job4")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job5"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job5")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job6"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job6")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job7"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job7")))])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("join.header.email")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('ul', {
    staticClass: "job-ul"
  }, [_c('li', {
    attrs: {
      "id": "job1"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job1.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job1.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job2"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job2.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job2.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job3"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job3.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job3.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job3.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job4"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job4.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job4.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job4.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job5"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job5.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job5.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job5.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job6"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job6.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job6.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job6.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job7"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job7.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job7.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job7.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.require.value")))])])])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b08db72","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/join.vue
// module id = 44
// module chunks = 0